import Shepherd from 'shepherd.js'
import toursEnabled from 'src/helpers/onboarding/toursEnabled'

// Global on/off switch for onboarding walkthroughs (Shepherd.js tours).
//
// When TOURS_ENABLED is false (see config/*.env.js) we patch the prototype
// `start` to be a no-op. This intentionally covers BOTH paths into a tour:
//   1. the useShepherdTour composable, and
//   2. the ~dozen inline `new Shepherd.Tour({...}).start()` call sites.
// Keeping the kill switch at this single point means we don't have to
// thread the feature flag through every caller.
export default () => {
  if (toursEnabled()) {
    return
  }
  Shepherd.Tour.prototype.start = function () {
    return this
  }
}
